// removed by extract-text-webpack-plugin
module.exports = {"Base":"MostPopular__Base-2zYSd","Articles":"MostPopular__Articles-1Ihsz","Article":"MostPopular__Article-2rG_E","Link":"MostPopular__Link-TiMiy","Link--withNumbers":"MostPopular__Link--withNumbers-yQOhT MostPopular__Link-TiMiy","Content":"MostPopular__Content-3hBvB","Content--withNumbers":"MostPopular__Content--withNumbers-1HB25 MostPopular__Content-3hBvB","Header":"MostPopular__Header-3iKD3","Title":"MostPopular__Title-1Njgc"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/MostPopular/MostPopular.css
 ** module id = 635
 ** module chunks = 0
 **/